"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMuTxt = exports.SlateEditorContextProvider = exports.SlateEditorContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.SlateEditorContext = React.createContext(null);
const SlateEditorContextProvider = ({ state, children }) => React.createElement(exports.SlateEditorContext.Provider, { value: state }, children);
exports.SlateEditorContextProvider = SlateEditorContextProvider;
const useMuTxt = () => {
    const state = React.useContext(exports.SlateEditorContext);
    if (!state)
        throw new Error('useSlateEditorState must be used inside SlateEditorContextProvider.');
    return state;
};
exports.useMuTxt = useMuTxt;
